import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Button } from "@jammable/ui-core"; // Assuming Button can be used for icon buttons
import PropTypes from "prop-types"; // Import PropTypes

// Define the component using JavaScript syntax
const BackButton = ({
  onClick,
  className = "",
  "aria-label": ariaLabel = "Go back",
}) => {
  return (
    <Button
      className={`tw-bg-gray-100 tw-border tw-border-solid tw-border-black/10 hover:tw-bg-gray-200 tw-p-0 md:tw-p-0 tw-size-10 tw-rounded-2xl tw-flex tw-items-center tw-justify-center ${className}`}
      size="icon"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <FaArrowLeft size={16} className="tw-text-black/60" />
    </Button>
  );
};

// Add PropTypes for type checking
BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
};

export default BackButton;
